/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { createSlice } from '@reduxjs/toolkit';
import { getAllPersonnelUserList } from './personnelAction';

const initialState = {
    data: {},
    personnelUsers: {}
}
const personnelSlice = createSlice({
    name: 'personnel',
    initialState,
    extraReducers: {
        [getAllPersonnelUserList.fulfilled]: (state, { payload }) => {
            state.personnelUsers = payload;
        },
    }
});

export default personnelSlice.reducer;